import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

interface ModalContextValue {
  registerModal: (isOpen: boolean) => void;
}

const ModalContext = createContext<ModalContextValue | undefined>(undefined);

const getScrollbarWidth = () =>
  window.innerWidth - document.documentElement.clientWidth;

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openCount, setOpenCount] = useState(0);

  const registerModal = useCallback((isOpen: boolean) => {
    setOpenCount((prev) => {
      const next = isOpen ? prev + 1 : Math.max(0, prev - 1);
      return next;
    });
  }, []);

  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;
    if (openCount > 0) {
      const scrollbarWidth = getScrollbarWidth();
      body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';
      html.setAttribute('data-modal-open', 'true');
      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    } else {
      body.style.overflow = '';
      body.style.paddingRight = '';
      html.style.overflow = '';
      html.removeAttribute('data-modal-open');
    }
  }, [openCount]);

  return (
    <ModalContext.Provider value={{ registerModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModalManager = () => {
  const context = useContext(ModalContext);
  if (!context) {
    return { registerModal: () => undefined };
  }
  return context;
};
